const topics = [
  { name: '国产悬疑剧', heat: '9.8万讨论', tag: '爆' },
  { name: '科幻电影推荐', heat: '7.2万讨论', tag: '热' },
  { name: '韩剧高分合集', heat: '6.5万讨论', tag: '热' },
  { name: '综艺名场面', heat: '5.8万讨论', tag: '新' },
  { name: '日漫新番追踪', heat: '5.1万讨论', tag: '热' },
  { name: '假期片单推荐', heat: '4.6万讨论', tag: '荐' },
  { name: '经典老片回顾', heat: '3.9万讨论', tag: '' },
  { name: '纪录片精选', heat: '3.2万讨论', tag: '' },
  { name: '动画电影专题', heat: '2.8万讨论', tag: '新' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            全网影视热议，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group flex items-center gap-3 bg-background-50 border border-background-200 rounded-full pl-5 pr-3 py-2.5 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {topic.heat}
              </span>
              {topic.tag && (
                <span
                  className={`px-2 py-0.5 text-xs font-bold rounded-full whitespace-nowrap ${
                    topic.tag === '爆'
                      ? 'bg-primary-500 text-background-50'
                      : topic.tag === '热'
                      ? 'bg-accent-500 text-background-50'
                      : topic.tag === '新'
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-accent-100 text-accent-700'
                  }`}
                >
                  {topic.tag}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}